import { reducer } from 'rxbeach';
import { ApiServiceState, CrudActions, EntityTypeItem } from './types';

export type ApiServiceShape = {
  state: ApiServiceState;
  error: any;
};

export const defaultApiServiceShape = {
  state: ApiServiceState.READY,
  error: null,
};

export const crudApiServiceReducers = <
  Request,
  EntityType extends EntityTypeItem
>(
  actions: CrudActions<Request, EntityType>
) => [
  reducer(
    [actions.apiGetItems, actions.apiCreate, actions.apiPut, actions.apiDelete],
    (state: ApiServiceShape) => ({
      ...state,
      state: ApiServiceState.LOADING,
    })
  ),
  reducer(
    [actions.setItems, actions.create, actions.put, actions.remove],
    (state: ApiServiceShape) => ({
      ...state,
      state: ApiServiceState.SUCCESS,
    })
  ),
  reducer(actions.error, (state: ApiServiceShape, error) => ({
    ...state,
    state: ApiServiceState.ERROR,
    error,
  })),
];
